/* BG-343: make the game picture a link on the home Judge.me reviews strip and the Customer reviews page.
   Does nothing when Judge.me's classes are missing. Reviews page: reuse the picture anchor, copy the name link's
   href, and stop Judge.me's lightbox (a capture listener stops only bubbling handlers, never the default navigation).
   Home: each picture links to its own review on the Customer reviews page (URL passed from layout/theme.liquid as data-reviews-url). */
(function () {
  'use strict';
  var PATH = /^(\/[a-z]{2}(-[a-z]{2})?)?\/products\/[^/]+\/?$/i;

  function productPath(href) {
    try {
      var u = new URL(href, location.href);
      return u.origin === location.origin && PATH.test(u.pathname) ? u.pathname : '';
    } catch (e) { return ''; }
  }
  function norm(s) { return String(s || '').normalize('NFC').replace(/\s+/g, ' ').trim().toLowerCase(); }
  function tip(link, name) {
    var t = document.createElement('span');
    t.className = 'bgb-gl__tip';
    t.setAttribute('aria-hidden', 'true');
    t.textContent = name;
    link.appendChild(t);
  }

  /* Escape hides the label (WCAG 1.4.13); leaving the link brings it back. */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.bgb-gl:hover, .bgb-gl:focus').forEach(function (a) { a.setAttribute('data-tip-off', ''); });
  });
  ['pointerout', 'focusout'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      var a = e.target.closest && e.target.closest('.bgb-gl[data-tip-off]');
      if (a && !(e.relatedTarget && a.contains(e.relatedTarget))) a.removeAttribute('data-tip-off');
    });
  });

  /* ---------- Customer reviews page ---------- */
  var widget = document.querySelector('.jdgm-all-reviews-widget');
  if (widget) {
    var scan = function () {
      widget.querySelectorAll('a.jdgm-rev__pic-link:not([data-bgb-gl])').forEach(function (a) {
        var img = a.querySelector('img');
        var name = img ? (img.getAttribute('alt') || '').trim() : '';
        if (name && !a.hasAttribute('aria-label')) a.setAttribute('aria-label', name);
        if (!name) return; /* not ready yet: retried on the next scan */
        if (!a.classList.contains('jdgm-rev__product-picture')) { a.setAttribute('data-bgb-gl', ''); return; }
        var card = a.closest('.jdgm-rev');
        var nl = card && card.querySelector('.jdgm-rev__prod-link[href]');
        if (!nl || !productPath(nl.getAttribute('href'))) return;
        a.setAttribute('href', nl.getAttribute('href'));
        if (nl.hasAttribute('target')) a.setAttribute('target', nl.getAttribute('target'));
        else a.removeAttribute('target');
        a.removeAttribute('rel');
        a.setAttribute('tabindex', '-1');
        a.classList.add('bgb-gl');
        a.setAttribute('data-bgb-gl', 'link');
        tip(a, name);
      });
    };
    var queued = false;
    scan();
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; scan(); });
    }).observe(widget, { childList: true, subtree: true });
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('a.jdgm-rev__pic-link[data-bgb-gl="link"]')) e.stopPropagation();
    }, true);

    /* #review-<uuid> from the home strip: scroll to that review and ring it briefly (BG-343 r1.3). The id is
       checked against the regex before it reaches querySelector. Waits for Judge.me to render (5 s if the review is missing). */
    var hit = /^#review-([0-9a-f-]{36})$/i.exec(location.hash);
    if (hit) {
      var t0 = Date.now(), t1 = 0, key = '', timer = 0, mo, iv, evs = ['wheel', 'touchstart', 'keydown', 'pointerdown'];
      /* one place ends the handling: user scroll intent (incl. scrollbar drag = pointerdown), the deadline, or the settle window */
      var finish = function () {
        mo.disconnect(); clearInterval(iv);
        evs.forEach(function (ev) { removeEventListener(ev, finish); });
        removeEventListener('load', onLoad);
      };
      var jump = function () {
        var now = Date.now(), r = widget.querySelector('.jdgm-rev[data-review-id="' + hit[1] + '"]');
        /* missing: give up after 5 s; present but not laid out yet (slow page): up to 30 s; after the first scroll: 5 s more for layout shifts */
        if (now - t0 > (r ? 30000 : 5000) || (t1 && now - t1 > 5000)) return finish();
        /* --header-height is unset at 768px and narrower (same as finder-sentence.js): use the sticky header's own height */
        var hdr = r && !getComputedStyle(document.documentElement).getPropertyValue('--header-height').trim() && document.querySelector('store-header');
        if (hdr) r.style.scrollMarginTop = hdr.offsetHeight + 12 + 'px';
        var box = r && r.getBoundingClientRect();
        if (!box || !box.height) return;
        /* re-correct only when the review's page position or the header offset changed, never on viewport position alone (a user drag must stick) */
        var margin = parseFloat(getComputedStyle(r).scrollMarginTop || 0), k = Math.round(box.top + scrollY) + '/' + margin;
        if (t1 && k === key) return;
        key = k;
        /* the browser's own hash scroll often lands it already (scroll-margin-top): ring it once anyway, scroll only if off */
        t1 = t1 || now;
        r.setAttribute('tabindex', '-1');
        if (Math.abs(box.top - margin) > 4) r.scrollIntoView({ block: 'start', behavior: 'instant' });
        r.focus({ preventScroll: true });
        r.classList.add('bgb-rev--hit');
        clearTimeout(timer); /* the ring lasts 2.5 s after the last scroll */
        timer = setTimeout(function () { r.classList.remove('bgb-rev--hit'); }, 2500);
      };
      var onLoad = function () { if (t1) t1 = Date.now(); jump(); }; /* images finishing shift the page: 5 s more */
      evs.forEach(function (ev) { addEventListener(ev, finish, { passive: true }); });
      mo = new MutationObserver(jump);
      mo.observe(widget, { childList: true, subtree: true });
      iv = setInterval(jump, 250); /* layout shifts from late images; jump() ends it at the deadline */
      addEventListener('load', onLoad);
      jump();
    }
  }

  /* ---------- Home strip: every picture opens the Customer reviews page (BG-343 r1.2) ---------- */
  var script = document.currentScript;
  var REVIEWS = script && script.getAttribute('data-reviews-url');
  var strips = document.querySelectorAll('.jdgm-carousel');
  if (REVIEWS && strips.length) {
    var tabIO = new Map();
    var link = function (it) {
      var box = it.querySelector('.jdgm-carousel-item__product');
      var img = box && box.querySelector('img.jdgm-carousel-item__product-image');
      var name = img && (img.getAttribute('alt') || '').trim();
      if (!name || box.querySelector('a.bgb-gl')) return;
      var a = document.createElement('a');
      a.className = 'bgb-gl';
      var rid = it.getAttribute('data-review-id');
      a.href = /^[0-9a-f-]{36}$/i.test(rid || '') ? REVIEWS + '#review-' + rid : REVIEWS;
      a.setAttribute('aria-label', name + ': read this review');
      tip(a, name);
      box.appendChild(a);
      img.setAttribute('alt', '');
      /* one Tab stop per fully visible card; hidden cards stay out of the Tab order */
      var root = it.closest('.jdgm-carousel__item-container');
      if (!root || !('IntersectionObserver' in window)) return;
      var io = tabIO.get(root);
      if (!io) {
        io = new IntersectionObserver(function (es) {
          es.forEach(function (en) {
            var l = en.target.querySelector('a.bgb-gl');
            if (l) l.tabIndex = en.intersectionRatio >= 0.9 ? 0 : -1;
          });
        }, { root: root, threshold: [0, 0.9] });
        tabIO.set(root, io);
      }
      a.tabIndex = -1;
      io.observe(it);
    };
    strips.forEach(function (c) {
      c.querySelectorAll('.jdgm-carousel-item:not(.jdgm--shop-review)').forEach(link);
    });
  }
})();
